module.exports = __webpack_public_path__ + "img/how_to_print_chrome.ddc27ebb.png";